module.exports = __webpack_public_path__ + "assets/img/lh_avatar.f1a00b2a.png";